import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { WiseIdAuthServiceManager } from './wise-id-auth.service-manager';
import { Observable } from 'rxjs';


@Injectable({
	providedIn: 'root'
})
export class WiseIdAuthGuard implements CanActivate {
	constructor(
		private wiseIdAuthServiceManager: WiseIdAuthServiceManager,
		private router: Router
	) { }

	canActivate(): Observable<boolean> | Promise<boolean> | boolean {
		const isAuthenticated = this.wiseIdAuthServiceManager.isLoggedIn();
		if (!isAuthenticated) {
			this.router.navigate(['/login']);
		}
		return isAuthenticated;
	}
}